function Error() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="6" fill="#E81212"/>
            <path
                d="M8.47946 9.10403H7.52746L7.32746 5.28802H8.67946L8.47946 9.10403ZM7.31146 10.44C7.31146 10.1947 7.37813 10.024 7.51146 9.92803C7.6448 9.82669 7.80746 9.77603 7.99946 9.77603C8.18613 9.77603 8.34613 9.82669 8.47946 9.92803C8.6128 10.024 8.67946 10.1947 8.67946 10.44C8.67946 10.6747 8.6128 10.8454 8.47946 10.952C8.34613 11.0534 8.18613 11.104 7.99946 11.104C7.80746 11.104 7.6448 11.0534 7.51146 10.952C7.37813 10.8454 7.31146 10.6747 7.31146 10.44Z"
                fill="white"/>
        </svg>

    );
}

export default Error;
